/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EffectivePriceRowRates = {
  inputTokens?: number | undefined;
  outputTokens?: number | undefined;
  cachedTokens?: number | undefined;
  reasoningTokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  imageTiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

export const EffectivePriceRowSource = {
  OrgOverride: "org_override",
  ClusterDefault: "cluster_default",
  Unpriced: "unpriced",
} as const;
export type EffectivePriceRowSource = ClosedEnum<
  typeof EffectivePriceRowSource
>;

export type EffectivePriceRow = {
  model: string;
  rates: EffectivePriceRowRates | null;
  source: EffectivePriceRowSource;
};

/** @internal */
export const EffectivePriceRowRates$inboundSchema: z.ZodType<
  EffectivePriceRowRates,
  z.ZodTypeDef,
  unknown
> = z.object({
  input_tokens: z.number().optional(),
  output_tokens: z.number().optional(),
  cached_tokens: z.number().optional(),
  reasoning_tokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  image_tiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    "input_tokens": "inputTokens",
    "output_tokens": "outputTokens",
    "cached_tokens": "cachedTokens",
    "reasoning_tokens": "reasoningTokens",
    "image_tiers": "imageTiers",
  });
});
/** @internal */
export type EffectivePriceRowRates$Outbound = {
  input_tokens?: number | undefined;
  output_tokens?: number | undefined;
  cached_tokens?: number | undefined;
  reasoning_tokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  image_tiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

/** @internal */
export const EffectivePriceRowRates$outboundSchema: z.ZodType<
  EffectivePriceRowRates$Outbound,
  z.ZodTypeDef,
  EffectivePriceRowRates
> = z.object({
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  cachedTokens: z.number().optional(),
  reasoningTokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  imageTiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    inputTokens: "input_tokens",
    outputTokens: "output_tokens",
    cachedTokens: "cached_tokens",
    reasoningTokens: "reasoning_tokens",
    imageTiers: "image_tiers",
  });
});

export function effectivePriceRowRatesToJSON(
  effectivePriceRowRates: EffectivePriceRowRates,
): string {
  return JSON.stringify(
    EffectivePriceRowRates$outboundSchema.parse(effectivePriceRowRates),
  );
}
export function effectivePriceRowRatesFromJSON(
  jsonString: string,
): SafeParseResult<EffectivePriceRowRates, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EffectivePriceRowRates$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EffectivePriceRowRates' from JSON`,
  );
}

/** @internal */
export const EffectivePriceRowSource$inboundSchema: z.ZodNativeEnum<
  typeof EffectivePriceRowSource
> = z.nativeEnum(EffectivePriceRowSource);
/** @internal */
export const EffectivePriceRowSource$outboundSchema: z.ZodNativeEnum<
  typeof EffectivePriceRowSource
> = EffectivePriceRowSource$inboundSchema;

/** @internal */
export const EffectivePriceRow$inboundSchema: z.ZodType<
  EffectivePriceRow,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string(),
  rates: z.nullable(z.lazy(() => EffectivePriceRowRates$inboundSchema)),
  source: EffectivePriceRowSource$inboundSchema,
});
/** @internal */
export type EffectivePriceRow$Outbound = {
  model: string;
  rates: EffectivePriceRowRates$Outbound | null;
  source: string;
};

/** @internal */
export const EffectivePriceRow$outboundSchema: z.ZodType<
  EffectivePriceRow$Outbound,
  z.ZodTypeDef,
  EffectivePriceRow
> = z.object({
  model: z.string(),
  rates: z.nullable(z.lazy(() => EffectivePriceRowRates$outboundSchema)),
  source: EffectivePriceRowSource$outboundSchema,
});

export function effectivePriceRowToJSON(
  effectivePriceRow: EffectivePriceRow,
): string {
  return JSON.stringify(
    EffectivePriceRow$outboundSchema.parse(effectivePriceRow),
  );
}
export function effectivePriceRowFromJSON(
  jsonString: string,
): SafeParseResult<EffectivePriceRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EffectivePriceRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EffectivePriceRow' from JSON`,
  );
}
